import styled from 'styled-components';

// content
export const Content = styled.div`
    box-sizing: border-box;
    flex-grow: 1;
`;
